import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ReplacementDeviceList from "./list/ReplacementDeviceList";
import { ButtonToolbar, notifyToast, ToastType } from "../../../components";
import { saveDevice } from "../api-handler/api-handler";
import { DisplaySpinnerContext, RouteGuardContext, TabPanelContext } from "../../../context/ContextIndex";
import { selectSessionConfig } from "../../../store/store-selector";
import ReplacementDeviceCreate from "./create/ReplacementDeviceCreate";
import { setBackDropLoader } from "../../../components-old/ComponentsIndex";

const ReplacementDeviceView = () => {
  const navigate = useNavigate();
  const _tabContextObject = useContext(TabPanelContext);
  const routeGuardContext = useContext(RouteGuardContext);
  const _tabContext = _tabContextObject.getTabFormContext();
  const editDeviceId = _tabContext.editDeviceId;

  const spinnerCtx = useContext(DisplaySpinnerContext);
  const settingsConfig = useSelector(selectSessionConfig);
  const [showForm, setShowForm] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const replacementDevice = _tabContext.data?.replacementDevice ? _tabContext.data?.replacementDevice.length : 0;

  const handleAddClick = () => {
    setShowForm(true);
  };

  //on cancel of create replacement device form
  const handleCancelForm = () => {
    _tabContextObject.setTabFormContext({
      data: {
        ..._tabContext.data,
        selectedReplacementDevice: null,
      },
    });
    setShowForm(false);
  };

  const onCancel = () => {
    try {
      navigate("/devicelist");
    } catch (err) {
      alert(err);
    }
  };

  //on submit of device group
  const onSubmit = async () => {
    console.log("onDeviceSubmit");
    try {
      spinnerCtx.setLoadingIndicator(true);
      routeGuardContext.setFormState(false);
      const status = await saveDevice(_tabContext.data, {
        editDeviceId,
        settingsConfig,
        formdata: _tabContext.prevData,
      });

      if (status?.responseStatus === 200) {
        notifyToast("Sent for approval", ToastType.SUCCESS);
        spinnerCtx.setLoadingIndicator(false);
        onCancel();
      } else {
        notifyToast("Device creation failed", ToastType.ERROR);
        spinnerCtx.setLoadingIndicator(false);
      }
    } catch (err) {
      spinnerCtx.setLoadingIndicator(false);
      alert(err);
    }
  };

  //on submit of replacement device form
  const handleFormSubmit = () => {
    setShowForm(false);
  };

  useEffect(() => {
    routeGuardContext.setFormState(_tabContext?.isDirty);
    setIsFormValid(_tabContext?.isDirty);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showForm]);

  return (
    <>
      {!showForm ? (
        <>
          {setBackDropLoader(spinnerCtx.isLoading)}
          <ReplacementDeviceList onAddClick={handleAddClick} setShowForm={setShowForm} setIsFormValid={setIsFormValid} />
          <ButtonToolbar
            onCancel={onCancel}
            onSubmit={onSubmit}
            isFormValid={replacementDevice > 0 && isFormValid ? true : false}
            isWithAppForm={false}
          />
        </>
      ) : (
        <ReplacementDeviceCreate onSubmit={handleFormSubmit} onCancel={handleCancelForm} />
      )}
    </>
  );
};

export default ReplacementDeviceView;
